import React, { useState } from "react";
import { shuffle, sampleSize } from "lodash";

import Button from "../Button";
import ScoreOverlay from "../ScoreOverlay";

import {
  Wrapper,
  DossierWrapper,
  Card,
  Title,
  Description,
  Pic,
  DotsWrapper,
  Dot,
  ArrowLeft,
  ArrowRight,
  StepTitle
} from "./styled";
import dossiers from "../dossiers";

const characterIds = shuffle([1, 2, 3, 4, 5]);

function Dossier({ onNext, onIncrement, onSetCharacter }) {
  const [randomDossiers] = useState(
    sampleSize(dossiers, 4).map((d, i) => ({
      ...d,
      character: characterIds[i]
    }))
  );
  const [selectedId, setSelectedId] = useState(0);
  const [scoreOverlay, setScoreOverlay] = useState(false);

  const current = randomDossiers[selectedId];

  const handleNext = () => {
    if (selectedId < randomDossiers.length - 1) {
      setSelectedId(selectedId + 1);
    } else {
      setSelectedId(0);
    }
  };

  const handlePrev = () => {
    if (selectedId > 0) {
      setSelectedId(selectedId - 1);
    } else {
      setSelectedId(randomDossiers.length - 1);
    }
  };

  const handleButtonClick = () => {
    setScoreOverlay(true);
    setTimeout(() => {
      setScoreOverlay(false);
      onIncrement(current.score);
      onSetCharacter(current);
      onNext();
    }, 1000);
  };

  return (
    <Wrapper>
      <StepTitle>
        У какого научного руководителя больше всего подопечных с фальшивыми
        диссертациями?
      </StepTitle>
      <DossierWrapper>
        <ArrowLeft onClick={handlePrev} />
        <Card>
          <Title>{current.name}</Title>
          <Description>{current.text}</Description>
          <Pic id={current.character} />
        </Card>
        <ArrowRight onClick={handleNext} />
      </DossierWrapper>
      <DotsWrapper>
        {randomDossiers.map((d, i) => (
          <Dot key={i} active={i === selectedId} />
        ))}
      </DotsWrapper>
      <Button onClick={handleButtonClick}>Выбрать</Button>
      {scoreOverlay && <ScoreOverlay score={current.score} />}
    </Wrapper>
  );
}

export default Dossier;
